import { FC } from 'react';
import cn from 'classnames';

import { HeaderPhones } from 'src/shared/ui/HeaderPhones';

import styles from './styles.module.scss';

import { usePhoneNumbers } from '../lib';
import type { ITopBarMobile } from '../config/declarations';

const TopBarMobile: FC<ITopBarMobile> = ({ topBar }) => {
  const phoneNumbers = usePhoneNumbers(topBar?.phonesCollection);

  if (!topBar) {
    return null;
  }

  return (
    <section className={cn(styles.topBar, styles.mobile)}>
      <HeaderPhones phoneNumbers={phoneNumbers} />
    </section>
  );
};

export default TopBarMobile;
